import { render, staticRenderFns } from "./IoStatus.vue?vue&type=template&id=f55076ca&scoped=true"
import script from "./IoStatus.vue?vue&type=script&lang=js"
export * from "./IoStatus.vue?vue&type=script&lang=js"
import style0 from "./IoStatus.vue?vue&type=style&index=0&id=f55076ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f55076ca",
  null
  
)

export default component.exports